import React from 'react'

export default function RequestTeam() {
  return (
    <div>Request Team</div>
  )
}
